import React from 'react';

import {Stack, Typography} from '@mui/material';

import {useCountdown} from '../../../hooks/useCountdown/index';
import {CounterProps} from './types';

export function Counter({initialValueInSeconds}: CounterProps) {
	const {counterValue} = useCountdown(initialValueInSeconds);

	return (
		<Stack gap={2}>
			<Typography color="text.secondary" textAlign="center">
				{counterValue}
			</Typography>
		</Stack>
	);
}
